import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "bg-[#EEEEEE] pt-[6rem] pb-[6rem]" }
const _hoisted_2 = { className: "mx-auto max-w-7xl sm:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { className: "text-[1.25rem] px-6 leading-[1.2] sm:px-0 sm:text-[57px] text-[#02021E] font-[800] text-center m-auto pb-[2rem]" }, [
  /*#__PURE__*/_createTextVNode(" A place of trust for "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" millions of people ")
], -1)
const _hoisted_4 = { class: "justify-center md:justify-between flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card2 = _resolveComponent("Card2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Card2, {
          title: "- Karen Lynn",
          subTitle: "Financial analyst",
          src_image: "div.client-img.png",
          content: "“Greatest appreciation to you and your team for the outstanding job you did for us. The app is just what we wanted.”"
        }),
        _createVNode(_component_Card2, {
          title: "- Sean Jacobs",
          subTitle: "Financial analyst",
          src_image: "div.client-img.png",
          content: "“Greatest appreciation to you and your team for the outstanding job you did for us. The app is just what we wanted.”"
        }),
        _createVNode(_component_Card2, {
          title: "- Scott Swanson",
          subTitle: "Financial analyst",
          src_image: "div.client-img.png",
          content: "“Greatest appreciation to you and your team for the outstanding job you did for us. The app is just what we wanted.”"
        })
      ])
    ])
  ]))
}